import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {METERS_PER_KILOMETER, METERS_PER_MILE} from "../../utils/distance-unit.util";


export class SiteDistanceInputCtrl implements IController {
  value: number;
  min: number;
  addStepToMin: boolean;
  max: number;
  step: number;
  formName: string;
  isRequired: boolean;
  label: string | undefined;
  onChange: Function;

  public siteDistanceUnit: string;

  public shortenCalculatedValue: number;
  public calculatedMin: number;
  public calculatedMax: number;


  /* @ngInject */
  constructor(private splitService) {
    this.siteDistanceUnit = splitService.getSiteDistanceSmallUnit();
  }

  $onInit() {
    // this.shortenCalculatedValue = !_.isUndefined(this.value) ? Math.round(this.distanceUnitConverter(this.value)) : undefined;
    // this.calculatedMin = !_.isUndefined(this.min) ? Math.round(this.distanceUnitConverter(this.min) + (this.addStepToMin ? 1 : 0)) : 0;
    // this.calculatedMax = !_.isUndefined(this.max) ? Math.round(this.distanceUnitConverter(this.max)) : undefined;

    this.shortenCalculatedValue = !_.isUndefined(this.value) ? parseFloat(this.distanceUnitConverter(this.value).toFixed(2)) : undefined;
    this.calculatedMin = !_.isUndefined(this.min) ? parseFloat((this.distanceUnitConverter(this.min) + (this.addStepToMin ? 1 : 0)).toFixed(2)) : 0;
    this.calculatedMax = !_.isUndefined(this.max) ? parseFloat(this.distanceUnitConverter(this.max).toFixed(2)) : undefined;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if ((changes.value) ||
      (changes.min) ||
      (changes.max)) {
      this.$onInit();
    }
  }

  private distanceUnitConverter(value: number) {
    let calculatedValue;
    switch (this.siteDistanceUnit) {
      case 'Meter': {
        calculatedValue = value / METERS_PER_KILOMETER;
        break;
      }
      case 'Foot': {
        calculatedValue = value / METERS_PER_MILE;
        break;
      }
    }
    return calculatedValue;
  }

  public valueChanged(shortenCalculatedValue) {
    let value;
    switch (this.siteDistanceUnit) {
      case 'Meter': {
        value = !_.isNil(shortenCalculatedValue) ? shortenCalculatedValue * METERS_PER_KILOMETER : undefined;
        break;
      }
      case 'Foot': {
        value = !_.isNil(shortenCalculatedValue) ? shortenCalculatedValue * METERS_PER_MILE : undefined;
        break;
      }
    }
    this.onChange({value: value});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('siteDistanceInput', {
    require: {
      form: '^form'
    },
    bindings: {
      value: '<',
      min: '<',
      addStepToMin: '<?',
      max: '<',
      isRequired: '<?',
      label: '<?',
      formName: '@',
      onChange: '&'
    },
    template: require('./site-distance-input.html').default,
    controller: SiteDistanceInputCtrl
  });
